const exportTable = (columns, rows) => {
  const downloadableColumns = columns.filter(
    (column) =>
      column.getIsVisible() && column.columnDef.enableDownload !== false
  );

  const data = rows.map((row) => {
    return downloadableColumns.reduce((acc, column) => {
      const { downloadFn } = column.columnDef;
      const value = row.getValue(column.id);
      acc[column.id] = downloadFn ? downloadFn(value) : value;
      return acc;
    }, {});
  });

  return {
    fields: downloadableColumns.map((column) => column.columnDef.header),
    data,
  };
};

export default exportTable;
